module.exports = __webpack_public_path__ + "img/laverie-nantes-easy-laverie.9e0e8aab.svg";